import { useEffect, useState } from 'react'

interface QrOverlayProps {
  /** The URL the QR code encodes (opens the app on the phone for AR). */
  url: string
  onClose: () => void
}

/**
 * Desktop-only modal: shows a QR code that a phone scans to open this cover on the
 * phone, where AR ("View in your space") is available. The QR is generated locally.
 */
export function QrOverlay({ url, onClose }: QrOverlayProps) {
  const [dataUrl, setDataUrl] = useState<string | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const QRCode = (await import('qrcode')).default
        const png = await QRCode.toDataURL(url, { width: 320, margin: 1, errorCorrectionLevel: 'M' })
        if (!cancelled) setDataUrl(png)
      } catch (e) {
        console.error('QR generation failed:', e)
        if (!cancelled) setError(true)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [url])

  return (
    <div className="overlay overlay--center qr" onClick={onClose}>
      <div className="qr__card" onClick={(e) => e.stopPropagation()}>
        <div className="qr__title">View in AR on your phone</div>
        <div className="qr__sub">Scan this code with your phone’s camera to open this cover, then tap AR.</div>
        <div className="qr__code">
          {dataUrl ? (
            <img src={dataUrl} alt="QR code to open the cover preview on your phone" width={256} height={256} />
          ) : error ? (
            <div className="qr__err">Couldn’t generate the QR code.</div>
          ) : (
            <div className="loader__spinner" />
          )}
        </div>
        <button className="btn btn--wide" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
